import { Navigate, Route, Routes } from "react-router-dom";
import { ConfigProvider } from "./components/ConfigProvider";
import { Layout } from "./components/Layout";
import { ToastProvider } from "./components/Toast";
import { CarrierRequestScreen } from "./screens/CarrierRequest";
import { CarriersScreen } from "./screens/Carriers";
import { CommissionsScreen } from "./screens/Commissions";
import { CustomerScreen } from "./screens/Customer";
import { CustomersScreen } from "./screens/Customers";
import { DocumentsScreen } from "./screens/Documents";
import { FormDraftScreen } from "./screens/FormDraft";
import { FormsScreen } from "./screens/Forms";
import { GuideScreen } from "./screens/Guide";
import { ImportScreen } from "./screens/Import";
import { ImportBatchScreen } from "./screens/ImportBatch";
import { InboxScreen } from "./screens/Inbox";
import { IntakeScreen } from "./screens/Intake";
import { NoticesScreen } from "./screens/Notices";
import { ClaimsScreen } from "./screens/Claims";
import { PaymentsScreen } from "./screens/Payments";
import { PortalScreen } from "./screens/Portal";
import { SignScreen } from "./screens/Sign";
import { PipelinesScreen } from "./screens/Pipelines";
import { PoliciesScreen } from "./screens/Policies";
import { QuoteScreen } from "./screens/Quote";
import { RenewalsScreen } from "./screens/Renewals";
import { ReportsScreen } from "./screens/Reports";
import { SettingsScreen } from "./screens/Settings";
import { SetupScreen } from "./screens/Setup";
import { SignInScreen } from "./screens/SignIn";
import { TodayScreen } from "./screens/Today";

export function App() {
  return (
    <Routes>
      {/* Public, unauthenticated website intake. No app chrome. */}
      <Route path="/intake" element={<IntakeScreen />} />
      {/* Public, no auth: the customer's self-service page and the signing page; the token in the URL is the key. */}
      <Route path="/my/:token" element={<PortalScreen />} />
      <Route path="/sign/:token" element={<SignScreen />} />
      {/* Sign-in (passcode gate or Clerk). No app chrome. */}
      <Route path="/sign-in/*" element={<SignInScreen />} />
      <Route path="/sign-up/*" element={<SignInScreen variant="sign-up" />} />
      <Route path="/*" element={<Shell />} />
    </Routes>
  );
}

function Shell() {
  return (
    <ConfigProvider>
      <ToastProvider>
        <Routes>
          {/* Setup wizard renders without the full chrome so the first run feels like onboarding, not a settings page. */}
          <Route path="/setup" element={<SetupScreen />} />
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<TodayScreen />} />
                  <Route path="/guide" element={<GuideScreen />} />
                  <Route path="/pipelines" element={<Navigate to="/pipelines/sales" replace />} />
                  <Route path="/pipelines/:kind" element={<PipelinesScreen />} />
                  <Route path="/customers" element={<CustomersScreen />} />
                  <Route path="/customers/:id" element={<CustomerScreen />} />
                  <Route path="/quotes/:quoteRequestId" element={<QuoteScreen />} />
                  <Route path="/inbox" element={<InboxScreen />} />
                  <Route path="/renewals" element={<RenewalsScreen />} />
                  <Route path="/policies" element={<PoliciesScreen />} />
                  <Route path="/forms" element={<FormsScreen />} />
                  <Route path="/forms/:draftId" element={<FormDraftScreen />} />
                  <Route path="/import" element={<ImportScreen />} />
                  <Route path="/import/:batchId" element={<ImportBatchScreen />} />
                  <Route path="/carriers" element={<CarriersScreen />} />
                  <Route path="/carriers/requests/:requestId" element={<CarrierRequestScreen />} />
                  <Route path="/reports" element={<ReportsScreen />} />
                  <Route path="/commissions" element={<CommissionsScreen />} />
                  <Route path="/notices" element={<NoticesScreen />} />
                  <Route path="/claims" element={<ClaimsScreen />} />
                  <Route path="/payments" element={<PaymentsScreen />} />
                  <Route path="/documents" element={<DocumentsScreen />} />
                  <Route path="/settings" element={<SettingsScreen />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </ToastProvider>
    </ConfigProvider>
  );
}
